import React, { useState } from "react";
import PayslipModal from "../components/PayslipModal";
import SectionHeader from "../components/SectionHeader";
import { Eye } from "lucide-react";

/* INPUT COMPONENT */
const Input = ({ name, value, onChange }) => {
  return (
    <input
      type="text"
      name={name}
      value={value || ""}
      onChange={onChange}
      className="w-full px-2 py-1 outline-none"
    />
  );
};

export default function PayslipPage() {
  const [open, setOpen] = useState(false);

  const [form, setForm] = useState({
    employeeId: "",
    employeeName: "",

    bankName: "",
    bankAccount: "",

    doj: "",
    groupDoj: "",
    ifsc: "",

    designation: "",
    department: "",
    location: "",

    uan: "",
    pfNo: "",
    esiNo: "",

    days: "",
    lop: "",
    lopr: "",
    arrearDays: "",

    month: "",
    year: "",

    /* Earnings */
    basic: "",
    basicYTD: "",

    hra: "",
    hraYTD: "",

    allowance: "",
    allowanceYTD: "",

    bonus: "",
    bonusYTD: "",

    incentive: "",
    incentiveYTD: "",

    /* Deductions */
    professionTax: "",
    professionTaxYTD: "",

    pf: "",
    pfYTD: "",

    labourFund: "",
    labourFundYTD: "",

    ewf: "",
    ewfYTD: "",

    lwfAdjust: "",
    lwfAdjustYTD: "",

    /* Net Pay */
    netPay: "",
    netPayWords: "",

    /* PF DETAILS */
    pfEmployee: "",
    pfEmployeeYTD: "",

    vpf: "",
    vpfYTD: "",

    eps: "",
    epsYTD: "",

    employerPF: "",
    employerPFYTD: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <div className="min-h-screen p-4 bg-slate-200">
      <SectionHeader title="Pay Slip" subTitle="Generate Pay Slip" />
      <div className="bg-white border shadow rounded">
        {/* EMPLOYEE DETAILS */}
        <table className="w-full border-collapse text-sm">
          <tbody>
            <tr>
              <td className="border p-2 w-[20%]">Employee ID</td>
              <td className="border p-2">
                <Input
                  name="employeeId"
                  value={form.employeeId}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">Bank Name</td>
              <td className="border p-2">
                <Input
                  name="bankName"
                  value={form.bankName}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Employee Name</td>
              <td className="border p-2">
                <Input
                  name="employeeName"
                  value={form.employeeName}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">Bank A/C No</td>
              <td className="border p-2">
                <Input
                  name="bankAccount"
                  value={form.bankAccount}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Date of Joining</td>
              <td className="border p-2">
                <Input name="doj" value={form.doj} onChange={handleChange} />
              </td>

              <td className="border p-2">Group DOJ</td>
              <td className="border p-2">
                <Input
                  name="groupDoj"
                  value={form.groupDoj}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Bank IFSC Code</td>
              <td className="border p-2">
                <Input name="ifsc" value={form.ifsc} onChange={handleChange} />
              </td>

              <td className="border p-2">Designation</td>
              <td className="border p-2">
                <Input
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Universal Account Number</td>
              <td className="border p-2">
                <Input name="uan" value={form.uan} onChange={handleChange} />
              </td>

              <td className="border p-2">Department</td>
              <td className="border p-2">
                <Input
                  name="department"
                  value={form.department}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">PF No.</td>
              <td className="border p-2">
                <Input name="pfNo" value={form.pfNo} onChange={handleChange} />
              </td>

              <td className="border p-2">Work Location</td>
              <td className="border p-2">
                <Input
                  name="location"
                  value={form.location}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">ESI No</td>
              <td className="border p-2">
                <Input
                  name="esiNo"
                  value={form.esiNo}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">No of Days / LOP / LOPR</td>
              <td className="border p-2">
                <div className="flex gap-2">
                  <input
                    name="days"
                    value={form.days}
                    onChange={handleChange}
                    className="border px-1 w-12"
                  />
                  /
                  <input
                    name="lop"
                    value={form.lop}
                    onChange={handleChange}
                    className="border px-1 w-12"
                  />
                  /
                  <input
                    name="lopr"
                    value={form.lopr}
                    onChange={handleChange}
                    className="border px-1 w-12"
                  />
                </div>
              </td>
            </tr>

            <tr>
              <td className="border p-2">Arrear Paid Days</td>
              <td className="border p-2">
                <Input
                  name="arrearDays"
                  value={form.arrearDays}
                  onChange={handleChange}
                />
              </td>
              <td className="border"></td>
              <td className="border"></td>
            </tr>
          </tbody>
        </table>

        {/* MONTH */}
        <div className="bg-gray-200 p-2 font-semibold border-t border-b border-gray-400">
          Payslip for the month of
          <input
            name="month"
            value={form.month}
            onChange={handleChange}
            className="border mx-2 px-1"
          />
          <input
            name="year"
            value={form.year}
            onChange={handleChange}
            className="border px-1 w-20"
          />
        </div>

        <table className="w-full border-collapse text-sm ">
          <thead>
            <tr className="bg-gray-200">
              <th className="border p-2 text-left">Earnings</th>
              <th className="border p-2 text-right">Amount</th>
              <th className="border p-2 text-right">Year to Date</th>

              <th className="border p-2 text-left">Deductions</th>
              <th className="border p-2 text-right">Amount</th>
              <th className="border p-2 text-right">Year to Date</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="border p-2">Basic</td>
              <td className="border p-2">
                <Input
                  name="basic"
                  value={form.basic}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="basicYTD"
                  value={form.basicYTD}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">Profession Tax</td>
              <td className="border p-2">
                <Input
                  name="professionTax"
                  value={form.professionTax}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="professionTaxYTD"
                  value={form.professionTaxYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">H.R.A</td>
              <td className="border p-2">
                <Input name="hra" value={form.hra} onChange={handleChange} />
              </td>
              <td className="border p-2">
                <Input
                  name="hraYTD"
                  value={form.hraYTD}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">Provident Fund (PF)</td>
              <td className="border p-2">
                <Input name="pf" value={form.pf} onChange={handleChange} />
              </td>
              <td className="border p-2">
                <Input
                  name="pfYTD"
                  value={form.pfYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Special Allowance</td>
              <td className="border p-2">
                <Input
                  name="allowance"
                  value={form.allowance}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="allowanceYTD"
                  value={form.allowanceYTD}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">Labour Welfare Fund</td>
              <td className="border p-2">
                <Input
                  name="labourFund"
                  value={form.labourFund}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="labourFundYTD"
                  value={form.labourFundYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Statutory Bonus</td>
              <td className="border p-2">
                <Input
                  name="bonus"
                  value={form.bonus}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="bonusYTD"
                  value={form.bonusYTD}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">EWF</td>
              <td className="border p-2">
                <Input name="ewf" value={form.ewf} onChange={handleChange} />
              </td>
              <td className="border p-2">
                <Input
                  name="ewfYTD"
                  value={form.ewfYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Incentive</td>
              <td className="border p-2">
                <Input
                  name="incentive"
                  value={form.incentive}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="incentiveYTD"
                  value={form.incentiveYTD}
                  onChange={handleChange}
                />
              </td>

              <td className="border p-2">LWF adjustment</td>
              <td className="border p-2">
                <Input
                  name="lwfAdjust"
                  value={form.lwfAdjust}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="lwfAdjustYTD"
                  value={form.lwfAdjustYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>
          </tbody>
        </table>

        {/* NET PAY */}

        <div className="border-t p-2">
          Net Pay :
          <input
            name="netPay"
            value={form.netPay}
            onChange={handleChange}
            className="border ml-2 px-2"
          />
        </div>

        <div className="border-t p-2">
          Net Pay In Words :
          <textarea
            name="netPayWords"
            value={form.netPayWords}
            onChange={handleChange}
            className="border ml-2 px-2 py-1 w-[60%]"
          />
        </div>
        <table className="w-full border-collapse text-sm border-t">
          <thead className="bg-gray-200">
            <tr>
              <th className="border p-2 text-left w-[60%]">
                Provident Fund(PF) Details
              </th>
              <th className="border p-2 w-[20%]">Amount</th>
              <th className="border p-2 w-[20%]">Year to Date</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="border p-2">Employee Contribution to PF</td>
              <td className="border p-2">
                <Input
                  name="pfEmployee"
                  value={form.pfEmployee}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="pfEmployeeYTD"
                  value={form.pfEmployeeYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Employee VPF Contribution</td>
              <td className="border p-2">
                <Input name="vpf" value={form.vpf} onChange={handleChange} />
              </td>
              <td className="border p-2">
                <Input
                  name="vpfYTD"
                  value={form.vpfYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Employer Contribution to EPS</td>
              <td className="border p-2">
                <Input name="eps" value={form.eps} onChange={handleChange} />
              </td>
              <td className="border p-2">
                <Input
                  name="epsYTD"
                  value={form.epsYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>

            <tr>
              <td className="border p-2">Employer Contribution to PF</td>
              <td className="border p-2">
                <Input
                  name="employerPF"
                  value={form.employerPF}
                  onChange={handleChange}
                />
              </td>
              <td className="border p-2">
                <Input
                  name="employerPFYTD"
                  value={form.employerPFYTD}
                  onChange={handleChange}
                />
              </td>
            </tr>
          </tbody>
        </table>
        {/* BUTTON */}
        <div className="p-6 text-right flex justify-end">
          <button
            onClick={() => setOpen(true)}
            className="bg-sky-600 text-white px-6 py-2 rounded flex justify-center items-center gap-2"
          >
            Preview
            <Eye size={20} color="white" />
          </button>
        </div>
      </div>

      {open && <PayslipModal data={form} onClose={() => setOpen(false)} />}
    </div>
  );
}
